<template>
  <div class="mt-5">
    <b-card>
      <b-card-text>
        <b-row align-h="between">
          <b-col cols="12" sm="6">
            <b-row>
              <b-col cols="12" class="title">Datos de compra de tiquetes</b-col>
              <b-col cols="12" class="mt-3">
                <b-tabs
                  active-nav-item-class="font-weight-bold"
                  content-class="mt-3 p-2 avoid-overflow"
                >
                  <b-tab title="Compra de tiquetes" active>
                    <p class="tab-title">Aerolínea</p>
                    <b-form-select
                      id="airline-id"
                      class="ml-1 mt-2 mb-1"
                      size="lg"
                      value-field="id"
                      text-field="name"
                      :state="formErros.airline.is_valid"
                      :options="airlines"
                      :disabled="disableOptions"
                      @change="setDateToManagement"
                      v-model="formSend.airline"
                    >
                      <template #first>
                        <b-form-select-option :value="null" disabled>
                          Selecciona aerolinea
                        </b-form-select-option>
                      </template>
                    </b-form-select>
                    <b-form-invalid-feedback id="airline-id-feedback">
                      {{ formErros.airline.message }}
                    </b-form-invalid-feedback>
                    <p class="tab-title">Precio de tiquetes</p>
                    <b-form-input
                      id="price-id"
                      size="lg"
                      type="number"
                      placeholder="Escribe el valor de los tiquetes"
                      v-model="formSend.valueTicket"
                      :state="formErros.price.is_valid"
                      :disabled="disableOptions"
                      @input="inputToPrice"
                    />
                    <b-form-invalid-feedback id="price-id-feedback">
                      {{ formErros.price.message }}
                    </b-form-invalid-feedback>
                    <p class="tab-title">Bussines partner registrado</p>
                    <p>{{ businessPartnerLetter.name }}</p>
                    <p>Correo registrado: {{ businessPartnerLetter.email }}</p>

                    <p class="tab-title">Soporte de tiquetes</p>
                    <template v-if="iCanSeeFile">
                      <div class="content-file-pdf">
                        <div class="content-icon">
                          <span class="content-file-icon"></span>
                        </div>
                        <div
                          class="content-file-text pointer"
                          @click.prevent="downloadPDF"
                        >
                          <ins>
                            {{ fileDetails.name }}
                          </ins>
                          <div class="text-green" v-if="fileDetails.is_load">
                            archivo cargado
                            <span class="text-gray">
                              · {{ fileDetails.date_upload }}.
                            </span>
                          </div>
                        </div>
                        <div class="content-file-text-small">
                          <span
                            >{{ getFileSize(fileDetails.size) }}
                            <img
                              id="file"
                              src="@/assets/modules/permisos-sindicales/icons/uploader/remove.svg"
                              class="remove-file"
                              alt="vector"
                              @click.prevent="changeFile"
                            />
                          </span>
                        </div>
                      </div>
                    </template>
                    <template v-else>
                      <form
                        id="file-upload-form"
                        class="uploader-permisos-sindicales"
                        enctype="multipart/form-data"
                      >
                        <input
                          id="files"
                          ref="file"
                          type="file"
                          :disabled="disableOptions"
                          @change="selectedFile"
                          accept=".pdf"
                        />

                        <label for="files" id="file-drag" class="pointer">
                          <img
                            id="file"
                            src="@/assets/modules/permisos-sindicales/icons/uploader/vector.svg"
                            alt="vector"
                          />
                          <div id="start">
                            <div class="text-formatting-v2">
                              <strong>
                                Arrastra aquí el archivo tiquetes de viaje
                              </strong>
                            </div>
                            <div class="text-formatting-v2">Documento PDF</div>
                            <br />
                            <span
                              id="phones-btn"
                              class="button-v2 primary-permisos-sindicales text-formatting-v2"
                            >
                              <strong> Subir archivo </strong>
                            </span>
                          </div>
                        </label>
                      </form>
                    </template>
                    <p
                      class="text-danger text-size-error"
                      v-if="formErros.pdf.is_valid === false"
                    >
                      {{ formErros.pdf.message }}
                    </p>

                    <p class="tab-title">Comentario adicional</p>
                    <b-form-textarea
                      id="textarea-id"
                      placeholder="Escribe si tienes algún comentario adicional de la gestión de tiquetes para el Bussines partner"
                      rows="5"
                      max-rows="6"
                      :state="formErros.comment.is_valid"
                      :disabled="disableOptions"
                      v-model="formSend.comment"
                      @input="setDateToManagement"
                    ></b-form-textarea>
                    <b-form-invalid-feedback id="textarea-id-feedback">
                      {{ formErros.comment.message }}
                    </b-form-invalid-feedback>
                    <div v-if="dateManagement">
                      <p class="tab-title">Fecha de gestión de tiquetes</p>
                      <b-form-input
                        id="date-management"
                        size="lg"
                        placeholder="Fecha de gestión de tiquetes"
                        v-model="dateManagement"
                        :disabled="true"
                      />
                    </div>
                    <button
                      class="button-v2 primary-permisos-sindicales text-formatting-v2 mt-4"
                      :disabled="!iCanSendForm"
                      @click.prevent="submitForm"
                    >
                      {{ dateManagement ? "Editar" : "Enviar" }} tiquete
                      <img
                        src="@/assets/modules/permisos-sindicales/icons/btns/send.svg"
                        alt="send"
                        class="ml-2"
                      />
                    </button>
                  </b-tab>
                </b-tabs>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="12" sm="5" class="mt-5 mt-sm-0">
            <letter-component :letter="letter" :processing="processing" :managementId="managementId" />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <div class="mt-5 mb-4" v-if="idManagement">
      <h1 class="mb-4">Historial de modificaciones</h1>
      <b-card class="">
      <b-card-text>
          <TableHistory :managementId="idManagement" />
        </b-card-text>
      </b-card>
    </div>
    <!-- MODAL QUE SE MUESTRA DESPUES DE GUARDAR -->
    <modal-confirmation modal-id="success" @click:accepted="reloadPage">
      <template #body>
        <img
          class="col-4 my-3"
          src="@/assets/images/icons/ht_icon_checkbox_circle_line.svg"
        />
        <p class="text-formatting-v2 h2-v2 text-center">
          <strong> ¡Proceso exitoso! </strong>
        </p>
        <p class="text-formatting-v2 text-center">
          Se ha enviado correctamente tiquetes al BP
        </p>
      </template>
      <template #buttonText>
        <strong> Entendido </strong>
      </template>
    </modal-confirmation>
  </div>
</template>
<script>
import { airlineService } from "@/services/modules/common/airlines/service";
import {
  getLicenseManagementService,
  putLicenseManagementService,
} from "@/services/modules/permisos-sindicales/v2/licenses/gestor-impuestos/service";

import {
  APPROVED,
  PENDING,
  REJECTED,
} from "@/common/permisos-sindicales/requests/states";

export default {
  name: "management",
  props: {
    managementId: {
      type: Number,
      default: null,
    }
  },
  components: {
    letterComponent: () =>
      import(
        "@/components/Modules/PermisosSindicales/License/Management/Letter/Letter.vue"
      ),
    modalConfirmation: () =>
      import("@/components/common/modal/ModalConfirmation.vue"),
    TableHistory: () => import("@/components/Modules/PermisosSindicales/Requests/GestorImpuestos/Table/TableHistory.vue"),
  },
  data: () => ({
    airlines: [],
    letter: {},
    processing: true,
    formSend: {
      airline: null,
      valueTicket: null,
      unsigneValueTicket: null,
      comment: null,
      pdf: null,
      processing: false,
    },
    formErros: {
      pdf: {
        is_valid: null,
        message: "",
      },
      comment: {
        is_valid: null,
        message: "",
      },
      airline: {
        is_valid: null,
        message: "",
      },
      price: {
        is_valid: null,
        message: "",
      },
    },
    processingValueTicket: false,
    dateManagement: null,
    idManagement: null,
    tabIndex: 0,
  }),
  computed: {
    licenseId() {
      return Number(this.$route.params.id || 0);
    },
    // managementId() {
    //   return Number(this.$route.params.management || 0);
    // },
    businessPartnerLetter() {
      return (
        this.letter.business_partner ||
        Object.assign({
          name: null,
          email: null,
          society: null,
          signature: null,
          position: null,
        })
      );
    },
    // ## AEROLINEA
    getAirline() {
      const findAirline = (_id) => this.airlines.find(({ id }) => id === _id);
      return this.formSend.airline ? findAirline(this.formSend.airline) : null;
    },
    /// ## VALIDA SI ES EDITABLE
    validIsEdit() {
      const states = [APPROVED, PENDING, REJECTED];
      return states.includes(this.letter.management?.state);
    },
    // ## DISABLE A LAS OPCIONES
    disableOptions() {
      return !this.validIsEdit || this.processing;
    },
    // ## PUEDE VER EL ARCHIVO QUE SE SUBE
    iCanSeeFile() {
      return !!(this.formSend.pdf || this.letter.management?.file_name);
    },
    // ## EN CASO DE QUE SE MUESTRE EL ARCHIVO MOSTRAR UNA ESTRUCTURA DEFINIDA
    fileDetails() {
      return this.formSend.pdf
        ? {
            name: this.formSend.pdf.name,
            size: this.formSend.pdf.size,
            is_load: false,
          }
        : {
            name: this.letter.management?.file_name,
            size: this.letter.management?.file_size,
            is_load: true,
            date_upload: this.letter.management?.file_upload_date,
          };
    },
    // ## VALIDA SI SE PUEDE ENVIAR EL FORMULARIO
    iCanSendForm() {
      return (
        this.formSend.processing === false &&
        this.validIsEdit &&
        this.iCanSeeFile
      );
    },
  },
  watch: {
    processingValueTicket() {
      if (this.processingValueTicket === false) {
        this.formSend.unsigneValueTicket = this.formSend.valueTicket;
        this.formSend.valueTicket = this.parseToMoney(
          this.formSend.valueTicket
        );
        this.setDateToManagement();
      }
    },
    formSend: {
      handler() {
        this.letter.management.airline = this.getAirline;
      },
      deep: true,
    },
  },
  mounted() {
    // ## OBTIENE LA LISTA DE AEROLIENAS Y EL DETALLE DEL PERMISO
    Promise.all([
      airlineService(),
      getLicenseManagementService(this.licenseId, this.managementId),
    ])
      .then((responses) => {
        const [one, two] = responses;
        const {
          result: { data: airlines },
        } = one;
        const { result: letter } = two;
        this.airlines = airlines;
        this.letter = letter;
        this.dateManagement =
          this.letter?.management?.state !== "pending" || this.letter?.management?.state !== "rejected"
            ? this.$moment(this.letter.management.management_date).format(
                "D [de] MMMM [del] YYYY"
              )
            : null;
        this.idManagement = this.letter?.management?.state !== "pending"
            ? this.letter.management?.id : null;
        this.formSend.valueTicket = letter.management.price
          ? this.parseToMoney(letter.management.price)
          : null;
        this.formSend.unsigneValueTicket = letter.management.price ?? null;
        this.formSend.airline = letter.management?.airline?.id;
        this.formSend.comment = letter.management?.comment;
      })
      .catch(console.error)
      .finally(() => (this.processing = false));
  },
  methods: {
    //## ENVIO DEL FORMULARIO
    async submitForm() {
      if (!this.iCanSendForm) return;
      this.formSend.processing = true;
      let formData = new FormData();
      formData.append("airline_id", this.formSend.airline);
      formData.append("price", this.formSend.unsigneValueTicket);
      if (this.formSend.pdf) formData.append("file", this.formSend.pdf);
      if (this.formSend.comment)
        formData.append("comment", this.formSend.comment);
      await putLicenseManagementService(
        this.licenseId,
        this.managementId,
        formData
      )
        .then(() => this.$bvModal.show("success"))
        .catch(
          ({
            response: {
              data: {
                message: { file, airline_id, price, comment },
              },
            },
          }) => {
            this.formErros.pdf.is_valid = file ? false : null;
            this.formErros.pdf.message = file?.join(" ");
            this.formErros.airline.is_valid = airline_id ? false : null;
            this.formErros.airline.message = airline_id?.join(" ");
            this.formErros.price.is_valid = price ? false : null;
            this.formErros.price.message = price?.join(" ");
            this.formErros.comment.is_valid = comment ? false : null;
            this.formErros.comment.message = comment?.join(" ");
          }
        )
        .finally(() => (this.formSend.processing = false));
    },
    //## LUEGO DE QUE EL USUARIO DEJE DE INGRESAR VALORES SE CONVIERTE EN MONEDA LOCAL
    inputToPrice(value) {
      this.processingValueTicket = true;
      if (value) setTimeout(() => (this.processingValueTicket = false), 3500);
    },
    //## SUBIR EL ARCHIVO PDF
    selectedFile() {
      this.formSend.pdf = this.$refs.file.files[0];
      this.setDateToManagement();
    },
    //## SE LE ASIGNA LA FECHA A LA CARTA SI SE CAMBIA ALGUN VALOR
    setDateToManagement() {
      this.letter.management.management_date = this.get_today;
    },
    // ## RECARGAR LA PAGINA DESPUES DE DARLE ACEPTAR AL PROCESO DE GUARADADO
    reloadPage() {
      this.$bvModal.hide("success");
      location.reload();
    },
    // ## PERMITE SUBIR EL ARCHIVO NUEVAMENTE
    changeFile() {
      this.formSend.pdf = null;
      if (this.letter.management) this.letter.management.file_name = null;
    },
    // ## DESCARGAR PDF
    downloadPDF() {
      window.open(
        this.backendPath.concat(
          `/download/management/${this.letter.management?.file_id}`
        ),
        "_blank"
      );
    },
  },
};
</script>
